import { createSlice, PayloadAction } from '@reduxjs/toolkit';// Adjust this import based on your store file's location

// Define the type for the state
interface PrivilegedState {
  privileges: string[] | string; // Change `string[]` to another type if needed
}

// Initial state
const initialState: PrivilegedState = {
  privileges: [],
};
// Create the slice
const privilegeSlice = createSlice({
  name: 'privileged',
  initialState,
  reducers: {
    setPrivilegedArray: (state, action: PayloadAction<string[] | string>) => {
      state.privileges = action.payload;
    },
  },
});

// Export actions and selector
export const {
  setPrivilegedArray,
} = privilegeSlice.actions;

// Export the reducer
export default privilegeSlice.reducer;
